import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-plano-contas-empresa-detalhar',
  templateUrl: './plano-contas-empresa-detalhar.component.html',
  styleUrls: ['./plano-contas-empresa-detalhar.component.scss']
})
export class PlanoContasEmpresaDetalharComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  id?: number;
  planoContaEmpresa?: PlanoContaEmpresa;

  constructor(private planoContaEmpresaService: PlanoContaEmpresaService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService
  ) { super(erroService, storageService) }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PLANO_CONTAS_EMPRESA');
    this.buscarId();
    if (this.permissaoDetalhar) {
      this.carregarPlanoContaEmpresa();
    }
  }

  carregarPlanoContaEmpresa(){
    this.planoContaEmpresaService.buscarPorId(this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.planoContaEmpresa = data;
        this.loading = false;
      },
      error: (err : any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarId(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

}
